export const formData = {
  label: 'Enter Company Details',
  previewLabel: 'Confirm Company Details',
  progressBarSteps: [
    'Company Setup',
    'Enter Company Details',
    'Confirm Company Details',
  ],
  successIcon: 'https://i.ibb.co/RNvQN2X/success.png',
  errorIcon: 'https://i.ibb.co/GM7nsgp/icons8-error-48.png',
  selectFormLayout: [['companyType']],
  selectFormFields: [
    {
      type: 'select',
      compProps: {
        label: 'Select Company Incorporation Status',
        placeholder: 'Choose Incorporation Status',
        id: 'companyType',
        required: true,
        options: [
          {
            label: 'New',
            id: 'new',
          },
          {
            label: 'Existing',
            id: 'existing',
          },
        ],
      },
    },
  ],
  selectvalidatorConfig: {
    ruleSets: [
      {
        fields: {
          companyType: [
            {
              type: 'REQUIRED',
              errorMessage: 'Company Incorporation Status is required',
            },
          ],
        },
      },
    ],
  },
  fields: [
    {
      type: 'text',
      compProps: {
        label: 'Business Name',
        id: 'name',
        placeholder: 'Enter Business Name',
        required: true,
        disabled: true,
        readOnly: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Trading Name',
        id: 'tradingName',
        placeholder: 'Enter Trading Name',
        // required: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Company Registration No',
        id: 'registrationNo',
        placeholder: 'Enter Company Registration No',
        required: true,
      },
    },
    {
      type: 'datepicker',
      compProps: {
        label: 'Incorporation Date',
        id: 'incorporationDate',
        required: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Taxpayer Registration Nos',
        id: 'trn',
        placeholder: 'Enter Taxpayer Registration No',
        required: true,
        disabled: true,
        readOnly: true,
      },
    },
    {
      type: 'datepicker',
      compProps: {
        label: 'Expiry Date for TCC',
        id: 'tccExpiryDate',
        required: false,
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Company Type',
        id: 'type',
        required: true,
        options: [
          {
            label: 'Public/Government',
            id: 'GOVERNMENT',
          },

          {
            label: 'Private Organisation',
            id: 'PRIVATE_COMPANY',
          },
          {
            label: 'Diplomatic Mission',
            id: 'DIPLOMAT',
          },
          {
            label: 'Non-government organization',
            id: 'NGO',
          },
          {
            label: 'Charity/Voluntary Organisation',
            id: 'NON_GOVERNMENTAL',
          },
          {
            label: 'Religious Organisation',
            id: 'PRIVATE_INDIVIDUAL',
          },
        ],
      },
    },

    {
      type: 'multiSelect',
      compProps: {
        label: 'Nature of Business',
        id: 'natureOfBusiness',
        lookUpField: 'industryTypeList',
        placeholder: 'Enter Nature of Business',
        errorText1: 'Please select appropriate Nature of Business',
        required: true,
      },
    },
    {
      type: 'textarea',

      compProps: {
        label: 'Registered Address (Street 1)',
        rows: 1,
        id: 'addressLine1',
        placeholder: 'Enter Registered Address (Street 1)',
        required: true,
      },
    },
    {
      type: 'textarea',

      compProps: {
        label: 'Registered Address (Street 2)',
        rows: 1,
        id: 'addressLine2',
        placeholder: 'Enter Registered Address (Street 2)',
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Parish',
        id: 'parish',
        placeholder: 'Enter Parish',
        required: true,
        options: [
          {
            label: 'Clarendon',
            id: 'Clarendon',
          },
          {
            label: 'Hanover',
            id: 'Hanover',
          },
          {
            label: 'Kingston',
            id: 'Kingston',
          },
          {
            label: 'Manchester',
            id: 'Manchester',
          },
          {
            label: 'Portland',
            id: 'Portland',
          },
          {
            label: 'Saint Andrew',
            id: 'Saint Andrew',
          },
          {
            label: 'Saint Ann',
            id: 'Saint Ann',
          },
          {
            label: 'Saint Catherine',
            id: 'Saint Catherine',
          },
          {
            label: 'Saint Elizabeth',
            id: 'Saint Elizabeth',
          },
          {
            label: 'Saint James',
            id: 'Saint James',
          },
          {
            label: 'Saint Mary',
            id: 'Saint Mary',
          },
          {
            label: 'Saint Thomas',
            id: 'Saint Thomas',
          },
          {
            label: 'Trelawny',
            id: 'Trelawny',
          },
          {
            label: 'Westmoreland',
            id: 'Westmoreland',
          },
        ],
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'City/Town',
        id: 'city',
        placeholder: 'Enter City/Town',
        required: true,
        options: [],
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Postal Code',
        id: 'zipcode',
        placeholder: 'Enter Postal Code',
        // required: true,
      },
    },
    {
      type: 'textarea',

      compProps: {
        label: 'Operating Address (Street 1)',
        rows: 1,
        id: 'operatingaddressLine1',
        placeholder: 'Enter Operating Address (Street 1)',
        required: true,
      },
    },
    {
      type: 'textarea',

      compProps: {
        label: 'Operating Address (Street 2)',
        rows: 1,
        id: 'operatingaddressLine2',
        placeholder: 'Enter Operating Address (Street 2)',
        required: false,
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Parish',
        id: 'operatingParish',
        placeholder: 'Enter Parish',
        required: true,
        options: [
          {
            label: 'Clarendon',
            id: 'Clarendon',
          },
          {
            label: 'Hanover',
            id: 'Hanover',
          },
          {
            label: 'Kingston',
            id: 'Kingston',
          },
          {
            label: 'Manchester',
            id: 'Manchester',
          },
          {
            label: 'Portland',
            id: 'Portland',
          },
          {
            label: 'Saint Andrew',
            id: 'Saint Andrew',
          },
          {
            label: 'Saint Ann',
            id: 'Saint Ann',
          },
          {
            label: 'Saint Catherine',
            id: 'Saint Catherine',
          },
          {
            label: 'Saint Elizabeth',
            id: 'Saint Elizabeth',
          },
          {
            label: 'Saint James',
            id: 'Saint James',
          },
          {
            label: 'Saint Mary',
            id: 'Saint Mary',
          },
          {
            label: 'Saint Thomas',
            id: 'Saint Thomas',
          },
          {
            label: 'Trelawny',
            id: 'Trelawny',
          },
          {
            label: 'Westmoreland',
            id: 'Westmoreland',
          },
        ],
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'City/Town',
        id: 'operatingCity',
        placeholder: 'Enter City/Town',
        required: true,
        options: [],
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Postal Code',
        id: 'operatingzipcode',
        placeholder: 'Enter Postal Code',
        required: true,
      },
    },
    {
      type: 'radio',
      compProps: {
        label: 'Company Status',
        id: 'companyStatus',
        direction: 'horizontal',
        required: true,
        options: [
          {
            label: 'Active',
            id: 'active',
          },
          {
            label: 'Closed',
            id: 'closed',
          },
        ],
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Website',
        id: 'website',
        placeholder: 'Enter Website',
        required: false,
      },
    },
    {
      type: 'email',
      compProps: {
        label: 'Company Email',
        id: 'companyEmail',
        placeholder: 'Enter Email Address',
        required: true,
      },
    },
    {
      type: 'phoneNumber',
      compProps: {
        label: 'Phone Number (Mobile)',
        id: 'primaryContactNo',
        placeholder: 'Enter Phone Number',
        required: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Phone Number (Landline)',
        id: 'landlineContactNo',
        placeholder: 'Enter Landline Number',
        required: false,
      },
    },
    // {
    //   type: 'radio',
    //   compProps: {
    //     label: 'Status',
    //     id: 'status',    required:true,
    //     direction: 'horizontal',
    //     options: [
    //       {
    //         label: 'Active',
    //         id: 'active',
    //       },
    //       {
    //         label: 'InActive',
    //         id: 'inActive',
    //       },
    //     ],
    //   },
    // },
    {
      type: 'sectionTitle',
      compProps: {
        id: 'companyDirectors',
        label: 'Company Directors',
      },
    },
    {
      type: 'sectionTitle',
      compProps: {
        id: 'subsidiaryTitle',
        label: 'Subsidiary',
      },
    },
    {
      type: 'sectionTitle',
      compProps: {
        id: 'branch',
        label: 'Branches',
      },
    },

    {
      type: 'sectionTitle',
      compProps: {
        id: 'requiredDocuments',
        label: 'Required Documents',
      },
    },

    {
      type: 'checkBox',
      compProps: {
        id: 'confirmDetails',
        label: '',
        required: true,
        direction: 'vertical',
        options: [
          {
            id: 'confirmDetailsId',
            label:
              'I confirm that the above entered details are accurate and correct.',
          },
        ],
      },
    },

    {
      type: 'radio',
      compProps: {
        direction: 'horizontal',
        required: true,
        label: 'Is Operating Address same as Registered Address?',
        id: 'isAddressSame',
        options: [
          {
            label: 'Yes',
            id: 'yes',
          },
          {
            label: 'No',
            id: 'no',
          },
        ],
      },
    },
    {
      type: 'radio',
      compProps: {
        direction: 'horizontal',
        label: 'Do you want to add director',
        id: 'isAddDirector',
        required: true,
        options: [
          {
            label: 'Yes',
            id: 'yes',
          },
          {
            label: 'No',
            id: 'no',
          },
        ],
      },
    },
    {
      type: 'dynamicFields',
      compProps: {
        id: 'directors',
        cardType: 'Director',
        label: 'Directors',
        cardTitleField: 'firstName',
        required: true,
        hiddenFields: ['isLastNameExist'],
        attributeForm: {
          modalTitle: 'Add a Director',
          editTitle: 'Edit a Director',

          fields: [
            {
              type: 'radio',
              compProps: {
                label: 'Do you have a Last Name or Surname?',
                id: 'isLastNameExist',
                direction: 'horizontal',
                required: true,
                options: [
                  {
                    label: 'Yes',
                    id: 'yes',
                  },
                  {
                    label: 'No',
                    id: 'no',
                  },
                ],
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Last Name',
                id: 'lastName',
                placeholder: 'Enter Last Name',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'First Name (Given Name)',
                id: 'firstName',
                placeholder: 'Enter First Name',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Middle Name',
                id: 'middleName',
                placeholder: 'Enter Middle Name',
                required: false,
              },
            },

            {
              type: 'countrySelect',
              compProps: {
                label: 'Nationality',
                id: 'nationality',
                placeholder: 'Enter Nationality',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Occupation',
                id: 'occupation',
                placeholder: 'Enter Occupation',
                required: true,
              },
            },
            {
              type: 'email',
              compProps: {
                label: 'Email Address',
                id: 'email',
                placeholder: 'Enter Email address',
                required: true,
              },
            },
            {
              type: 'phoneNumber',
              compProps: {
                label: 'Contact Number',
                id: 'primaryContactNo',
                placeholder: 'Enter Contact Number',
                required: true,
              },
            },
          ],
          layout: [
            ['isLastNameExist'],
            ['firstName'],
            ['middleName'],
            ['nationality'],
            ['occupation'],
            ['email'],
            ['primaryContactNo'],
          ],
          dynamicLayout: {
            isLastNameExist: {
              yes: [['lastName']],
            },
          },
          validatorConfig: {
            ruleSets: [
              {
                fields: {
                  firstName: [
                    {
                      type: 'matches',
                      pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
                      errorMessage:
                        'First Name should contain atleast 2 characters.',
                    },
                  ],
                  middleName: [
                    {
                      type: 'matches',
                      pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
                      errorMessage: 'Middle Name contain atleast 2 characters.',
                    },
                  ],
                  lastName: [
                    {
                      type: 'matches',
                      pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
                      errorMessage: 'Last Name contain atleast 2 characters.',
                    },
                  ],
                  nationality: [
                    {
                      type: 'matches',
                      pattern: '^[A-Za-z ]+$',
                      errorMessage: 'Nationality should contain alphabets.',
                    },
                  ],
                  occupation: [
                    {
                      type: 'matches',
                      pattern: '^[A-Za-z ]+$',
                      errorMessage: 'Occupation should contain alphabets.',
                    },
                  ],
                  email: [
                    {
                      type: 'matches',
                      pattern:
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                      errorMessage: 'Please enter a valid email address',
                    },
                  ],
                },
              },
            ],
          },
        },
      },
    },
    {
      type: 'radio',
      compProps: {
        direction: 'horizontal',
        label: 'Do you want to add subsidiaries ',
        id: 'isAddSubsidiary',
        required: true,
        options: [
          {
            label: 'Yes',
            id: 'yes',
          },
          {
            label: 'No',
            id: 'no',
          },
        ],
      },
    },
    {
      type: 'dynamicFields',
      compProps: {
        id: 'subsidiaries',
        label: 'Subsidiaries',
        cardType: 'Subsidiary',
        required: true,
        cardTitleField: 'name',

        attributeForm: {
          modalTitle: 'Add a Subsidiary',
          editTitle: 'Edit a Subsidiary',

          fields: [
            {
              type: 'text',
              compProps: {
                label: 'Subsidiary Name',
                id: 'name',
                placeholder: 'Enter Subsidiary Name',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Trading Name',
                id: 'tradingName',
                placeholder: 'Enter Trading Name',
                // required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Contact Person',
                id: 'contactPerson',
                placeholder: 'Enter Contact Person',
                required: true,
              },
            },
            {
              type: 'textarea',

              compProps: {
                label: 'Registered Address (Street 1)',
                rows: 1,
                id: 'addressLine1',
                placeholder: 'Enter Registered Address (Street 1)',
                required: true,
              },
            },
            {
              type: 'textarea',

              compProps: {
                label: 'Registered Address (Street 2)',
                rows: 1,
                id: 'addressLine2',
                placeholder: 'Enter Registered Address (Street 2)',
              },
            },
            {
              type: 'select',
              compProps: {
                label: 'Parish',
                id: 'parish',
                placeholder: 'Enter Parish',
                required: true,
                options: [
                  {
                    label: 'Clarendon',
                    id: 'Clarendon',
                  },
                  {
                    label: 'Hanover',
                    id: 'Hanover',
                  },
                  {
                    label: 'Kingston',
                    id: 'Kingston',
                  },
                  {
                    label: 'Manchester',
                    id: 'Manchester',
                  },
                  {
                    label: 'Portland',
                    id: 'Portland',
                  },
                  {
                    label: 'Saint Andrew',
                    id: 'Saint Andrew',
                  },
                  {
                    label: 'Saint Ann',
                    id: 'Saint Ann',
                  },
                  {
                    label: 'Saint Catherine',
                    id: 'Saint Catherine',
                  },
                  {
                    label: 'Saint Elizabeth',
                    id: 'Saint Elizabeth',
                  },
                  {
                    label: 'Saint James',
                    id: 'Saint James',
                  },
                  {
                    label: 'Saint Mary',
                    id: 'Saint Mary',
                  },
                  {
                    label: 'Saint Thomas',
                    id: 'Saint Thomas',
                  },
                  {
                    label: 'Trelawny',
                    id: 'Trelawny',
                  },
                  {
                    label: 'Westmoreland',
                    id: 'Westmoreland',
                  },
                ],
              },
            },
            {
              type: 'select',
              compProps: {
                label: 'City/Town',
                id: 'city',
                placeholder: 'Enter City/Town',
                required: true,
                options: [],
              },
            },
            {
              type: 'countrySelect',
              compProps: {
                label: 'Country',
                id: 'country',
                placeholder: 'Enter Country',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Postal Code',
                id: 'zipcode',
                placeholder: 'Enter Postal Code',
                // required: true,
              },
            },
            {
              type: 'phoneNumber',
              compProps: {
                label: 'Office Number',
                id: 'primaryContactNo',
                placeholder: 'Enter Office Number',
                required: true,
              },
            },

            {
              type: 'email',
              compProps: {
                label: 'Email Address',
                id: 'email',
                placeholder: 'Enter Email address',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Website',
                id: 'website',
                placeholder: 'Enter Website',
                // required: true,
              },
            },
          ],
          layout: [
            ['name'],
            ['tradingName'],

            ['addressLine1'],
            ['addressLine2'],
            ['parish', 'city'],
            ['country'],
            ['zipcode'],
            ['contactPerson'],
            ['primaryContactNo'],
            ['email'],
            ['website'],
          ],
          validatorConfig: {
            ruleSets: [
              {
                fields: {
                  // name: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Name is invalid.',
                  //   },
                  // ],
                  tradingName: [
                    {
                      type: 'matches',
                      pattern: "^[A-Za-z0-9 .,'@&()\\-/:#]+$",
                      errorMessage: 'Name is invalid.',
                    },
                  ],
                  // city: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'City should contain alphabets.',
                  //   },
                  // ],
                  // state: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Parish should contain alphabets.',
                  //   },
                  // ],
                  // country: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Country should contain alphabets.',
                  //   },
                  // ],
                  zipcode: [
                    {
                      type: 'matches',
                      pattern: '^[0-9]+$',
                      errorMessage:
                        'Postal Code should contain numerical values.',
                    },
                  ],
                  email: [
                    {
                      type: 'matches',
                      pattern:
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                      errorMessage: 'Please enter a valid email address',
                    },
                  ],
                  // website: [
                  //   {
                  //     type: 'matches',
                  //     pattern:
                  //       '^(https?://)?([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.[a-zA-Z]{2,}([/?#].*)?$',
                  //     errorMessage: 'Invalid Website',
                  //   },
                  // ],
                },
              },
            ],
          },
        },
      },
    },
    {
      type: 'radio',
      compProps: {
        direction: 'horizontal',
        required: true,
        label: 'Do you want to add branch ',
        id: 'isAddBranch',
        options: [
          {
            label: 'Yes',
            id: 'yes',
          },
          {
            label: 'No',
            id: 'no',
          },
        ],
      },
    },
    {
      type: 'dynamicFields',
      compProps: {
        id: 'branches',
        label: 'Branches',
        required: true,
        cardType: 'Branch',
        cardTitleField: 'name',

        attributeForm: {
          modalTitle: 'Add a Branch',
          editTitle: 'Edit a Branch',

          fields: [
            {
              type: 'text',
              compProps: {
                label: 'Branch Name',
                id: 'name',
                placeholder: 'Enter Branch Name',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Contact Person',
                id: 'contactPerson',
                placeholder: 'Enter Contact Person',
                required: true,
              },
            },
            {
              type: 'textarea',

              compProps: {
                label: 'Registered Address (Street 1)',
                rows: 1,
                id: 'addressLine1',
                placeholder: 'Enter Registered Address (Street 1)',
                required: true,
              },
            },
            {
              type: 'textarea',

              compProps: {
                label: 'Registered Address (Street 2)',
                rows: 1,
                id: 'addressLine2',
                placeholder: 'Enter Registered Address (Street 2)',
              },
            },
            {
              type: 'select',
              compProps: {
                label: 'Parish',
                id: 'parish',
                placeholder: 'Enter Parish',
                required: true,
                options: [
                  {
                    label: 'Clarendon',
                    id: 'Clarendon',
                  },
                  {
                    label: 'Hanover',
                    id: 'Hanover',
                  },
                  {
                    label: 'Kingston',
                    id: 'Kingston',
                  },
                  {
                    label: 'Manchester',
                    id: 'Manchester',
                  },
                  {
                    label: 'Portland',
                    id: 'Portland',
                  },
                  {
                    label: 'Saint Andrew',
                    id: 'Saint Andrew',
                  },
                  {
                    label: 'Saint Ann',
                    id: 'Saint Ann',
                  },
                  {
                    label: 'Saint Catherine',
                    id: 'Saint Catherine',
                  },
                  {
                    label: 'Saint Elizabeth',
                    id: 'Saint Elizabeth',
                  },
                  {
                    label: 'Saint James',
                    id: 'Saint James',
                  },
                  {
                    label: 'Saint Mary',
                    id: 'Saint Mary',
                  },
                  {
                    label: 'Saint Thomas',
                    id: 'Saint Thomas',
                  },
                  {
                    label: 'Trelawny',
                    id: 'Trelawny',
                  },
                  {
                    label: 'Westmoreland',
                    id: 'Westmoreland',
                  },
                ],
              },
            },
            {
              type: 'select',
              compProps: {
                label: 'City/Town',
                id: 'city',
                placeholder: 'Enter City/Town',
                required: true,
                options: [],
              },
            },
            {
              type: 'countrySelect',
              compProps: {
                label: 'Country',
                id: 'country',
                placeholder: 'Enter Country',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Postal Code',
                id: 'zipcode',
                placeholder: 'Enter Postal Code',
                // required: true,
              },
            },
            {
              type: 'phoneNumber',
              compProps: {
                label: 'Telephone Number',
                id: 'primaryContactNo',
                placeholder: 'Enter Telephone Number',
                required: true,
              },
            },
            {
              type: 'email',
              compProps: {
                label: 'Email Address',
                id: 'email',
                placeholder: 'Enter Email address',
                required: true,
              },
            },
            {
              type: 'text',
              compProps: {
                label: 'Website',
                id: 'website',
                placeholder: 'Enter Website',
                // required: true,
              },
            },
          ],
          layout: [
            ['name'],
            ['addressLine1'],
            ['addressLine2'],
            ['parish', 'city'],
            ['country'],
            ['zipcode'],
            ['primaryContactNo'],
            ['contactPerson'],
            ['email'],
            ['website'],
          ],
          validatorConfig: {
            ruleSets: [
              {
                fields: {
                  // name: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Name is invalid.',
                  //   },
                  // ],
                  // city: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'City should contain alphabets.',
                  //   },
                  // ],
                  // parish: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Parish should contain alphabets.',
                  //   },
                  // ],
                  // country: [
                  //   {
                  //     type: 'matches',
                  //     pattern: '^[A-Za-z ]+$',
                  //     errorMessage: 'Country should contain alphabets.',
                  //   },
                  // ],
                  zipcode: [
                    {
                      type: 'matches',
                      pattern: '^[0-9]+$',
                      errorMessage:
                        'Postal Code should contain numerical values.',
                    },
                  ],
                  email: [
                    {
                      type: 'matches',
                      pattern:
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
                      errorMessage: 'Please enter a valid email address',
                    },
                  ],
                  // website: [
                  //   {
                  //     type: 'matches',
                  //     pattern:
                  //       '^(https?://)?([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.[a-zA-Z]{2,}([/?#].*)?$',
                  //     errorMessage: 'Invalid Website',
                  //   },
                  // ],
                },
              },
            ],
          },
        },
      },
    },
  ],
  newFields: [
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Business Registration',
        id: 'businessRegistration',
        supportedFormat: [
          'image/png',
          'application/pdf',
          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Business Registration is required',
      },
    },
    {
      type: 'datepicker',
      compProps: {
        label: 'Expiry Date for Business Registration',
        id: 'businessRegistrationExpiryDate',
        required: true,
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Tax Clearance Certificate (TCC)',
        id: 'taxClearanceCertificate',
        supportedFormat: [
          'image/png',
          'application/pdf',
          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Tax Clearance Certificate is required',
      },
    },
    // {
    //   type: 'datepicker',
    //   compProps: {
    //     label: 'Expiry Date for TCC',
    //     id: 'tccExpiryDate',
    //     required: false,
    //   },
    // },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Articles of Incorporation',
        id: 'articleOfIncorporation',
        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Articles of Incorporation is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Annual Return',
        id: 'annualReturn',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Annual Return is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Immigration Status',
        id: 'immigrationStatus',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Annual Return is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Certificate of Incorporation',
        id: 'certificateOfIncorporation',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Certificate of Incorporation is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Certificate of Good Standing',
        id: 'certificateOfGoodStading',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Certificate of Good Standing is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Bank Statement',
        id: 'bankStatement',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Bank Statement is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Existing Invoices',
        id: 'existingInvoices',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Existing Invoices is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Lease or Rental Agreement',
        id: 'leaseOrRentalAgreement',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Lease or Rental Agreement is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Companies office of Jamaica Receipt/Invoice',
        id: 'companyReceipt',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Companies office of Jamaica Receipt/Invoice is required',
      },
    },
  ],
  existingFields: [
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Business Registration',
        id: 'businessRegistration',
        supportedFormat: [
          'image/png',
          'application/pdf',
          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Business Registration is required',
      },
    },
    {
      type: 'datepicker',
      compProps: {
        label: 'Expiry Date for Business Registration',
        id: 'businessRegistrationExpiryDate',
        required: true,
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Tax Clearance Certificate (TCC)',
        id: 'taxClearanceCertificate',
        supportedFormat: [
          'image/png',
          'application/pdf',
          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Tax Clearance Certificate is required',
      },
    },
    // {
    //   type: 'datepicker',
    //   compProps: {
    //     label: 'Expiry Date for TCC',
    //     id: 'tccExpiryDate',
    //     required: true,
    //   },
    // },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Articles of Incorporation',
        id: 'articleOfIncorporation',
        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Articles of Incorporation is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Annual Return',
        id: 'annualReturn',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Annual Return is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Certificate of Incorporation',
        id: 'certificateOfIncorporation',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Certificate of Incorporation is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Certificate of Good Standing',
        id: 'certificateOfGoodStading',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: false,
        errorText: 'Certificate of Good Standing is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Bank Statement',
        id: 'bankStatement',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Bank Statement is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Existing Invoices',
        id: 'existingInvoices',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: false,
        errorText: 'Existing Invoices is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Lease or Rental Agreement',
        id: 'leaseOrRentalAgreement',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: true,
        errorText: 'Lease or Rental Agreement is required',
      },
    },
    {
      type: 'fileDropZone',
      compProps: {
        label: 'Companies office of Jamaica Receipt/Invoice',
        id: 'companyReceipt',

        supportedFormat: [
          'image/png',
          'application/pdf',

          'application/doc',
          'application/msword',
          'image/jpeg',
          'image/jpg',
        ],
        maxFiles: 1,
        required: false,
        errorText: 'Companies office of Jamaica Receipt/Invoice is required',
      },
    },
  ],
  existingLayout: [
    ['name'],
    ['tradingName'],
    ['registrationNo', 'incorporationDate'],
    ['trn', 'tccExpiryDate'],
    ['natureOfBusiness'],
    ['addressLine1'],
    ['addressLine2'],
    ['parish', 'city'],
    ['zipcode'],
    ['isAddressSame'],
    ['website', 'companyEmail'],
    ['primaryContactNo', 'landlineContactNo'],
    // ['userDetails'],
    // ['firstName', 'middleName'],
    // ['lastName', 'email'],
    // ['telephoneNumber', 'position'],
    // ['status'],
    ['companyDirectors'],
    ['isAddDirector'],
    ['subsidiaryTitle'],
    ['isAddSubsidiary'],
    ['branch'],
    ['isAddBranch'],
    ['requiredDocuments'],
    ['businessRegistration'],
    ['businessRegistrationExpiryDate'],
    ['taxClearanceCertificate'],
    ['tccExpiryDate'],
    ['articleOfIncorporation'],
    ['annualReturn'],
    ['certificateOfIncorporation'],
    ['certificateOfGoodStading'],
    ['bankStatement'],
    ['existingInvoices'],
    ['leaseOrRentalAgreement'],
    ['companyReceipt'],
  ],

  newLayout2: [
    {
      first: {
        label: 'Company Details',
        data: [
          ['name'],
          ['tradingName'],
          ['registrationNo', 'incorporationDate'],
          ['trn', 'tccExpiryDate'],
          ['natureOfBusiness'],
          ['addressLine1'],
          ['addressLine2'],
          ['parish', 'city'],
          ['zipcode'],
          ['isAddressSame'],
          ['website', 'companyEmail'],
          ['primaryContactNo', 'landlineContactNo'],
          // ['userDetails'],
          // ['firstName', 'middleName'],
          // ['lastName', 'email'],
          // ['telephoneNumber', 'position'],
          // ['status'],
        ],
      },
      second: {
        label: 'Managerial Details',
        data: [
          ['companyDirectors'],
          ['isAddDirector'],
          ['subsidiaryTitle'],
          ['isAddSubsidiary'],
          ['branch'],
          ['isAddBranch'],
        ],
      },
      third: {
        label: 'Documents',
        data: [
          ['type'],
          // ['requiredDocuments'],
          // ['businessRegistration'],
          // ['businessRegistrationExpiryDate'],
          // ['taxClearanceCertificate'],
          // ['tccExpiryDate'],
          // ['articleOfIncorporation'],
          // ['annualReturn'],
          // ['certificateOfIncorporation'],
          // ['certificateOfGoodStading'],
          // ['bankStatement'],
          // ['existingInvoices'],
          // ['leaseOrRentalAgreement'],
          // ['companyReceipt'],
        ],
      },
    },
  ],

  editLayout: [
    ['addressLine1'],
    ['addressLine2'],
    ['parish', 'city'],
    ['zipcode'],
    ['isAddDirector'],
    ['primaryContactNo'],
  ],

  newLayout: [
    ['name'],
    ['tradingName'],
    ['registrationNo', 'incorporationDate'],
    ['trn', 'tccExpiryDate'],
    ['natureOfBusiness'],
    ['addressLine1'],
    ['addressLine2'],
    ['parish', 'city'],
    ['zipcode'],
    ['isAddressSame'],
    ['website', 'companyEmail'],
    ['primaryContactNo', 'landlineContactNo'],
    // ['userDetails'],
    // ['firstName', 'middleName'],
    // ['lastName', 'email'],
    // ['telephoneNumber', 'position'],
    // ['status'],
    ['companyDirectors'],
    ['isAddDirector'],
    ['subsidiaryTitle'],
    ['isAddSubsidiary'],
    ['branch'],
    ['isAddBranch'],
    ['requiredDocuments'],
    ['businessRegistration'],
    ['businessRegistrationExpiryDate'],
    ['taxClearanceCertificate'],
    ['tccExpiryDate'],
    ['articleOfIncorporation'],
    ['annualReturn'],
    ['certificateOfIncorporation'],
    ['certificateOfGoodStading'],
    ['bankStatement'],
    ['existingInvoices'],
    ['leaseOrRentalAgreement'],
    ['companyReceipt'],
  ],
  confirmField: ['confirmDetails'],
  // ['requiredDocuments'],
  // ['businessRegistration'],
  // ['businessRegistrationExpiryDate'],
  // ['taxClearanceCertificate'],
  // ['tccExpiryDate'],
  // ['articleOfIncorporation'],
  // ['annualReturn'],
  // ['certificateOfIncorporation'],
  // ['certificateOfGoodStading'],
  // ['bankStatement'],
  // ['existingInvoices'],
  // ['leaseOrRentalAgreement'],
  // ['companyReceipt'],
  dynamicLayout: {
    isAddressSame: {
      no: [
        ['operatingaddressLine1'],
        ['operatingaddressLine2'],
        ['operatingParish', 'operatingCity'],
        ['operatingzipcode'],
      ],
    },
    type: {
      // GOVERNMENT: [['immigrationStatus']],
      // PUBLIC: [['immigrationStatus']],
      PRIVATE_INDIVIDUAL: [
        // ['immigrationStatus'],
        ['businessRegistrationExpiryDate'],
        ['annualReturn'],
        ['businessRegistration'],
      ],
      NON_GOVERNMENTAL: [
        // ['immigrationStatus'],
        ['businessRegistrationExpiryDate'],
        ['annualReturn'],
        ['certificateOfGoodStading'],
        ['businessRegistration'],
      ],
      NGO: [
        // ['immigrationStatus'],
        ['businessRegistrationExpiryDate'],
        ['annualReturn'],
        ['businessRegistration'],
      ],
      // DIPLOMAT: [['immigrationStatus']],
      PRIVATE_COMPANY: [
        // ['immigrationStatus'],
        ['businessRegistrationExpiryDate'],
        ['annualReturn'],
        ['bankStatement'],
        ['existingInvoices'],
        ['leaseOrRentalAgreement'],
        ['businessRegistration'],
      ],
    },
    isAddDirector: {
      yes: [['directors']],
    },
    isAddBranch: {
      yes: [['branches']],
    },
    isAddSubsidiary: {
      yes: [['subsidiaries']],
    },
  },
  validatorConfig: {
    ruleSets: [
      {
        fields: {
          // name: [
          //   {
          //     type: 'matches',
          //     pattern: '^[A-Za-z ]+$',
          //     errorMessage: 'Name is invalid.',
          //   },
          // ],
          firstName: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
              errorMessage: 'First Name/Given Name is invalid.',
            },
          ],
          middleName: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
              errorMessage: 'Middle Name is invalid.',
            },
          ],
          lastName: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
              errorMessage: 'Last Name is invalid.',
            },
          ],
          landlineContactNo: [
            {
              type: 'matches',
              pattern: '^[0-9]{6,8}$',
              errorMessage: 'Landline is invalid',
            },
          ],
          tradingName: [
            {
              type: 'matches',
              pattern: "^[A-Za-z0-9 .,'@&()\\-/:#]+$",
              errorMessage: 'Trading Name is invalid.',
            },
          ],
          incorporationDate: [
            {
              type: 'matches',
              pattern: '',
              errorMessage: 'Incorporation Date should not be future date.',
            },
          ],
          email: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$',
              errorMessage: 'Please enter a valid email address',
            },
          ],
          registrationNo: [
            {
              type: 'matches',
              pattern: '^[0-9]+$',
              errorMessage:
                'Company Registration No should contain numerical values.',
            },
          ],
          // trn: [
          //   {
          //     type: 'matches',
          //     pattern: '^[a-zA-Z0-9]+$',
          //     errorMessage:
          //       'Taxpayer Registration No should contain alphanumerical values.',
          //   },
          // ],
          zipcode: [
            {
              type: 'matches',
              pattern: '^[0-9]+$',
              errorMessage: 'Postal Code should contain numerical values.',
            },
          ],
          operatingzipcode: [
            {
              type: 'matches',
              pattern: '^[0-9]+$',
              errorMessage: 'Postal Code should contain numerical values.',
            },
          ],

          // city: [
          //   {
          //     type: 'matches',
          //     pattern: '^[A-Za-z ]+$',
          //     errorMessage: 'City should contain alphabets.',
          //   },
          // ],
          // parish: [
          //   {
          //     type: 'matches',
          //     pattern: '^[A-Za-z ]+$',
          //     errorMessage: 'Parish should contain alphabets.',
          //   },
          // ],
          // operatingCity: [
          //   {
          //     type: 'matches',
          //     pattern: '^[A-Za-z ]+$',
          //     errorMessage: 'City should contain alphabets.',
          //   },
          // ],
          // operatingParish: [
          //   {
          //     type: 'matches',
          //     pattern: '^[A-Za-z ]+$',
          //     errorMessage: 'Parish should contain alphabets.',
          //   },
          // ],
          // website: [
          //   {
          //     type: 'matches',
          //     pattern:
          //       '^(https?://)?([a-zA-Z0-9-]+.)*[a-zA-Z0-9-]+.[a-zA-Z]{2,}([/?#].*)?$',
          //     errorMessage: 'Invalid Website',
          //   },
          // ],
        },
      },
    ],
  },
  // businessRegistration: 'BUSSINESS_REGISTRATION',
  //     taxClearanceCertificate: 'TAX_CLEARANCE_CERTIFICATE',
  //     articleOfIncorporation: 'ARTICAL_OF_INCORPORATION',
  //     certificateOfIncorporation: 'CERTIFICATE_OF_INCORPORATION',
  //     annualReturn: 'ANNUAL_RETURN',
  //     immigrationStatus: 'IMMIGRATION_STATUS',
  //     certificateOfGoodStading: 'CERTIFICATE_OF_GOOD_STANDING',
  //     bankStatement: 'BANK_STATMENT',
  //     existingInvoices: 'EXISTING_INVOICES',
  //     leaseOrRentalAgreement: 'LEASE_AGREEMENT',
  //     companyReceipt: 'COMPAY_OFFICE_OF_JAMAICA_RECEIPT',
  relatedDocuments: {
    GOVERNMENT: [
      // 'IMMIGRATION_STATUS'
    ],
    PUBLIC: [
      // 'IMMIGRATION_STATUS'
    ],
    PRIVATE_INDIVIDUAL: [
      // 'IMMIGRATION_STATUS',
      'ANNUAL_RETURN',
      'BUSSINESS_REGISTRATION',
    ],
    NON_GOVERNMENTAL: [
      // 'IMMIGRATION_STATUS',
      'ANNUAL_RETURN',
      'CERTIFICATE_OF_GOOD_STANDING',
      'BUSSINESS_REGISTRATION',
    ],
    NGO: [
      // 'IMMIGRATION_STATUS',
      'ANNUAL_RETURN',
      'BUSSINESS_REGISTRATION',
    ],
    DIPLOMAT: [
      // 'IMMIGRATION_STATUS'
    ],
    PRIVATE_COMPANY: [
      // 'IMMIGRATION_STATUS',
      'ANNUAL_RETURN',
      'BANK_STATMENT',
      'EXISTING_INVOICES',
      'LEASE_AGREEMENT',
      'BUSSINESS_REGISTRATION',
    ],
  },
};
